import { FormattedMessage } from 'react-intl'
import { useState } from 'react'
import CourseDescriptionPopup from '../../../../popups/CourseDescriptionPopup'
import { PackageExtras, PackageFooter, PackageHeader } from '../PackageItems'
import get from 'lodash/get'

const BookingDetailsCardExtras = ({
  title,
  footerTitle,
  items,
  totalAmount,
  showQuantity,
  showPrice,
  currency,
  itemsExtraLegend,
  isCoupon,
  onCouponRemove,
}) => {
  const [courseId, setCourseId] = useState()
  const [isOpen, setIsOpen] = useState(false)
  const showCourseDetails = (id) => {
    setCourseId(id)
    setIsOpen(true)
  }
  const onClose = () => setIsOpen(false)
  return (
    <div className='price-pan'>
      <PackageHeader
        showQuantity={showQuantity}
        showPrice={showPrice}
        title={title}
      />
      <PackageExtras
        items={items || []}
        isCoupon={isCoupon}
        currency={currency}
        onCouponRemove={onCouponRemove}
        showCourseDetails={showCourseDetails}
      />
      <PackageFooter
        message={footerTitle}
        currency={currency}
        totalPrice={totalAmount}
        isCoupon={isCoupon}
        couponItem={get(items, '[0]')}
      />
      {itemsExtraLegend && (
        <small className='price-information'>
          *<FormattedMessage id='paid-on' defaultMessage='To be paid on site' />
        </small>
      )}
      <CourseDescriptionPopup id={courseId} isOpen={isOpen} onClose={onClose} />
    </div>
  )
}

export default BookingDetailsCardExtras
